import React, { useEffect, useState } from "react";
import edMantra from "../../services/edMantra";
import ChartComponent from "../../Components/Chart/ChartComponent";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import CountUp from "react-countup";
const Track = () => {
  const { data } = useSelector((state) => state?.currentSession?.userInfo);
  const [TotalLeads, setTotalLeads] = useState([]); // array, not number
  const [totalsLeads, setTotalsLeads] = useState([]);

  const registration = Array.isArray(TotalLeads)
    ? TotalLeads.filter((item) => item.status === "Registration").length
    : 0;

  const admission = TotalLeads?.filter(
    (item) => item.status === "Admission"
  ).length;
  const job = TotalLeads?.filter((item) => item.status === "For Job").length;
  const closed = TotalLeads?.filter((item) => item.status === "Close").length;
  const assignedLeads = TotalLeads?.filter(
    (item) => item.status === "Assigned"
  ).length;
  const dead = TotalLeads?.filter((item) => item.status === "Dead Lead").length;
  const coldLeads = TotalLeads?.filter(
    (item) => item.status === "Cold Lead"
  ).length;
  const newLeads = TotalLeads?.filter(
    (item) => item.status === "New Lead"
  ).length;
  const hotLeads = TotalLeads?.filter(
    (item) => item.status === "Hot Lead"
  ).length;
  const warmLeads = TotalLeads?.filter(
    (item) => item.status === "Warm Lead"
  ).length;

  const [counts, setCounts] = useState({
    totalLeads: 0,
    closeLeads: 0,
    deadLeads: 0,
    liveLeads: 0,
    newLeads: 0,
    hotLeads: 0,
    warmLeads: 0,
    coldLeads: 0,
    assignedLeads: 0,
    registration: 0,
    admission: 0,
    job: 0,
  });
  const chartData = {
    labels: [
      "Total Leads",
      "Close Leads",
      "Dead Leads",
      "Live Leads",
      "New Leads",
      "Hot Leads",
      "Warm Leads",
      "Cold Leads",
      "Assigned Leads",
    ],
    values: [
      counts.totalLeads,
      counts.closeLeads,
      counts.deadLeads,
      counts.liveLeads,
      counts.newLeads,
      counts.hotLeads,
      counts.warmLeads,
      counts.coldLeads,
      counts.assignedLeads,
    ],
  };

  const fetchCount = async (query) => {
    const isAdmin =
      data?.role?.roleName === "AdminDm" ||
      data?.role?.roleName === "SuperAdmin";

    if (isAdmin) {
      const res = await edMantra.getAllLeads(`page=1&limit=1&${query}`);
      return res?.data?.totalCount ?? 0;
    } else {
      const res = await edMantra.getLeadByEmpId(
        data?.empId,
        `page=1&limit=1&${query}`
      );
      return res?.data?.totalCount ?? 0;
    }
  };

  useEffect(() => {
    const loadCounts = async () => {
      try {
        // 3️⃣ fire all mini‑queries in parallel
        const [
          total,
          close,
          dead,
          reg,
          adm,
          job,
          assigned,
          newLead,
          hot,
          warm,
          cold,
        ] = await Promise.all([
          fetchCount(""), // total count
          fetchCount("status=Close"),
          fetchCount("status=Dead%20Lead"),
          fetchCount("status=Registration"),
          fetchCount("status=Admission"),
          fetchCount("status=For%20Job"),
          fetchCount("status=Assigned"),
          fetchCount("status=New%20Lead"),
          fetchCount("status=Hot%20Lead"),
          fetchCount("status=Warm%20Lead"),
          fetchCount("status=Cold%20Lead"),
        ]);

        setCounts({
          totalLeads: total,
          closeLeads: close,
          deadLeads: dead,
          liveLeads: total - close,
          newLeads: newLead,
          hotLeads: hot,
          warmLeads: warm,
          coldLeads: cold,
          assignedLeads: assigned,
          registration: reg,
          admission: adm,
          job: job,
        });
      } catch (e) {
        console.error("Failed to load lead counts", e);
      }
    };

    loadCounts();
  }, [data]);

  const totalLeads = async () => {
    try {
      const res = await edMantra.getAllLeads("page=1&limit=1"); // ⚠️ limit 1 is enough
      setTotalsLeads(res?.data?.totalCount ?? 0); // 💡 Use totalCount, not data.length
    } catch (error) {
      console.error("Error fetching total leads:", error);
      setTotalsLeads(0);
    }
  };

  useEffect(() => {
    totalLeads();
  }, []);

  const getAssignedLead = async () => {
    try {
      const query = `page=1&limit=1`; // Only fetch 1 record, get totalCount
      const leads = await edMantra.getLeadByEmpId(data?.empId, query);

      if (leads) {
        setTotalsLeads(leads?.data?.totalCount ?? 0); // Only use the count
      }
    } catch (error) {
      console.error("Error fetching assigned leads:", error);
      setTotalsLeads(0);
    }
  };

  useEffect(() => {
    if (
      data?.role?.roleName === "AdminDm" ||
      data?.role?.roleName === "SuperAdmin"
    ) {
      totalLeads();
    } else {
      getAssignedLead();
    }
  }, [data]);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-2 mb-2">
          <Link to="/salespipeLine" style={{ textDecoration: "none" }}>
            {" "}
            <div
              className="card border shadow h-100 py-2"
              style={{ backgroundColor: "rgba(177, 156, 217, 0.9)" }}
            >
              <div className="card-body">
                <div className="row no-gutters align-items-center">
                  <div className="col mr-2">
                    <div className="h6 text-xs font-weight-bold text-black text-uppercase mb-2">
                      Total Leads
                    </div>
                    <div className="h1 mb-0 font-weight-bold text-black">
                      <CountUp
                        end={counts.totalLeads}
                        duration={1.5}
                        separator=","
                      />
                      <i className="fas fa-calendar  text-black"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>

        <div className="col-md-2 mb-2">
          <Link
            to={{ pathname: "/salespipeLine", search: "?status=Close" }}
            style={{ textDecoration: "none" }}
          >
            {" "}
            <div
              className="card border shadow h-100 py-2"
              style={{ backgroundColor: "rgba(75, 192, 192, 0.9)" }}
            >
              <div className="card-body">
                <div className="row no-gutters align-items-center">
                  <div className="col mr-2">
                    <div className="h6 text-xs font-weight-bold text-black text-uppercase mb-2">
                      Close Leads
                    </div>
                    <div className="h1 mb-0 font-weight-bold text-black">
                      <CountUp
                        end={counts.closeLeads}
                        duration={1.5}
                        separator=","
                      />
                      <i className="fa fa-check-circle  text-black"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>

        <div className="col-md-2 mb-2">
          <Link to="/registration" style={{ textDecoration: "none" }}>
            <div
              className="card border shadow h-100 py-2"
              style={{ backgroundColor: "rgba(255, 99, 132, 0.9)" }}
            >
              <div className="card-body">
                <div className="row no-gutters align-items-center">
                  <div className="col mr-2">
                    <div className="h6 text-xs font-weight-bold text-black text-uppercase mb-2">
                      Registered
                    </div>
                    <div className="h1 mb-0 font-weight-bold text-black">
                      <CountUp
                        end={counts.registration}
                        duration={1.5}
                        separator=","
                      />
                      {counts.registration}
                      <i className="fa fa-book  text-black"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>

        <div className="col-md-2 mb-2">
          <Link to="/admission" style={{ textDecoration: "none" }}>
            {" "}
            <div
              className="card border shadow h-100 py-2"
              style={{ backgroundColor: "rgba(255, 153, 51, 0.9)" }}
            >
              <div className="card-body">
                <div className="row no-gutters align-items-center">
                  <div className="col mr-2">
                    <div className="h6 text-xs font-weight-bold text-black text-uppercase mb-2">
                      Admission
                    </div>
                    <div className="h1 mb-0 font-weight-bold text-black">
                      <CountUp
                        end={counts.admission}
                        duration={1.5}
                        separator=","
                      />
                      <i className="fa fa-flag-checkered  text-black"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>

        <div className="col-md-2 mb-2">
          <Link to="/salespipeLine" style={{ textDecoration: "none" }}>
            {" "}
            <div
              className="card border shadow h-100 py-2"
              style={{ backgroundColor: "rgba(51, 51, 255, 0.9)" }}
            >
              <div className="card-body">
                <div className="row no-gutters align-items-center">
                  <div className="col mr-2">
                    <div className="h6 text-xs font-weight-bold text-black text-uppercase mb-2">
                      For Job
                    </div>
                    <div className="h1 mb-0 font-weight-bold text-black">
                      <CountUp end={counts.job} duration={1.5} separator="," />
                      {counts.job}
                      <i className="fa fa-suitcase  text-black"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>

        <div className="col-md-2 mb-2">
          {" "}
          <Link to="/salespipeLine" style={{ textDecoration: "none" }}>
            {" "}
            <div
              className="card shadow h-100 py-2"
              style={{ backgroundColor: "rgba(51, 255, 153, 0.9)" }}
            >
              <div className="card-body">
                <div className="text-center">
                  {" "}
                  <div className="h6 text-xs font-weight-bold text-black text-uppercase mb-2">
                    Live Leads
                  </div>
                  <div className="h1 mb-0 font-weight-bold text-black">
                    <CountUp
                      end={counts.liveLeads}
                      duration={1.5}
                      separator=","
                    />
                    <i class="fa fa-line-chart" aria-hidden="true"></i>
                  </div>
                  <div className="row mt-2">
                    {/* <div className="col">
                    <div className="h6 text-xs font-weight-bold text-black text-uppercase">
                      New
                    </div>
                    <div className="h6 mb-0 font-weight-bold text-blqack">
                      {counts.newLeads}
                    </div>
                  </div> */}
                    <div className="col">
                      <div className="h6 text-xs font-weight-bold text-black text-uppercase">
                        Hot
                      </div>
                      <div className="h6 mb-0 font-weight-bold text-blqack">
                        <CountUp
                          end={counts.hotLeads}
                          duration={1.5}
                          separator=","
                        />
                      </div>
                    </div>
                    {/* <div className="col">
                    <div className="h6 text-xs font-weight-bold text-black text-uppercase">
                      Cold
                    </div>
                    <div className="h6 mb-0 font-weight-bold text-black">
                      {counts.coldLeads}
                    </div>
                  </div> */}
                    <div className="col">
                      <div className="h6 text-xs font-weight-bold text-black text-uppercase">
                        Warm
                      </div>
                      <div className="h6 mb-0 font-weight-bold text-black">
                        <CountUp
                          end={counts.warmLeads}
                          duration={1.5}
                          separator=","
                        />
                      </div>
                    </div>
                    {/* <div className="col">
                    <div className="h6 text-xs font-weight-bold text-black text-uppercase">
                      Dead
                    </div>
                    <div className="h6 mb-0 font-weight-bold text-black">
                      {counts.deadLeads}
                    </div>
                  </div> */}
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>

        {/* Graph */}
        <div className="col-lg-12">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">
                Leads Data Graph
              </h6>
            </div>
            <div className="card-body">
              <div className="chart-container">
                {/* <canvas ref={chartRef}></canvas> */}
                <ChartComponent data={chartData} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Track;
